"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _consentUtil = require("./consentUtil");
var ConsentListener = function ConsentListener(_ref) {
  var onConsentUpdate = _ref.onConsentUpdate;
  (0, _react.useEffect)(function () {
    window.addEventListener(_consentUtil.ONETRUST_EVENT, onConsentUpdate);
    return function () {
      return window.removeEventListener(_consentUtil.ONETRUST_EVENT, onConsentUpdate);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
};
var _default = exports["default"] = ConsentListener;